document.addEventListener('DOMContentLoaded', function () {
    const stickyHeader = document.querySelector('.wp-block-wpmundi-sticky-header');

    if (!stickyHeader) {
        return;
    }

    const overlapContent = stickyHeader.dataset.overlapContent === 'true';
    const adminBar = document.querySelector('#wpadminbar');
    // ✅ 1. LÊ a margem customizada a partir da variável CSS.
    // Usamos getComputedStyle para pegar o valor que o CSS está realmente usando.
    // parseFloat remove o 'px' para podermos fazer cálculos. O '|| 0' garante que temos um número.
    const topMargin = parseFloat(getComputedStyle(stickyHeader).getPropertyValue('--header-top-margin')) || 0;


    // --- PARTE 1: Lógica de Layout (Padding do Conteúdo) ---
    if (!overlapContent) {
        const mainContent = document.querySelector('main') || stickyHeader.nextElementSibling;
        
        function adjustMainContentPadding() {
            if (mainContent) {
                const headerHeight = stickyHeader.offsetHeight;
                // ✅ 2. CALCULA o padding somando a margem customizada com a altura do header.
                mainContent.style.paddingTop = `${topMargin + headerHeight}px`;
            }
        }
        const paddingObserver = new ResizeObserver(adjustMainContentPadding);
        paddingObserver.observe(stickyHeader);
        adjustMainContentPadding();
    }


    // --- PARTE 2: Lógica de Scroll (Posição e Cor) ---
    function handleScrollEffects() {
        const scrollY = window.scrollY;

        // Se o usuário estiver logado, ajusta a posição do header
        if (adminBar) {
            const adminBarHeight = adminBar.offsetHeight;
            const windowWidth = window.innerWidth;

            // ✅ 3. CALCULA a posição 'top' somando a margem customizada com a altura da barra de admin.
            if (windowWidth <= 600) {
                // Em telas pequenas, se a barra de admin já sumiu, o top é apenas a margem. Senão, é a soma.
                stickyHeader.style.top = (scrollY > adminBarHeight) ? `${topMargin}px` : `${topMargin + adminBarHeight}px`;
            } else {
                // Em telas grandes, é sempre a soma.
                stickyHeader.style.top = `${topMargin + adminBarHeight}px`;
            }
        }
        
        // Adiciona a classe .is-scrolled para mudar a cor
        const scrollTrigger = (adminBar ? adminBar.offsetHeight : 0) + topMargin + 10;
        if (scrollY > scrollTrigger) {
            stickyHeader.classList.add('is-scrolled');
        } else {
            stickyHeader.classList.remove('is-scrolled');
        }
    }

    window.addEventListener('scroll', handleScrollEffects);
    window.addEventListener('resize', handleScrollEffects);
    handleScrollEffects();
});